const posts = $('.post');

const checkVideo = (event, slick, currentSlide) => {
    const current = $(slick.$slides[currentSlide]);
    const video = current.find('.video');
    if (video.length) {
        video.removeClass('active');
        video.find('.removed').removeClass('removed');
        video.find('video')[0].pause();
        video.find('video')[0].currentTime = 0;
    }
}


$(document).ready(function () {
    posts.each((index, post) => {
        $(post).on('beforeChange', checkVideo)
    })
})
